import React from 'react';
import cx from 'classnames';
import { Link } from '@reach/router';
import styles from './ButtonLink.module.scss';

const ButtonLink = ({ children, disabled, fullWidth, large, outline, outlineBorder, to, state }) => {
    return (
        <Link 
            disabled={disabled} 
            to={to} 
            className={cx(styles.button, {[styles.buttonOutlineBorder]: outlineBorder,[styles.buttonFullWidth]: fullWidth}, {[styles.buttonLarge]: large}, {[styles.buttonOutline]: outline})}
            state={state && state}
        >
            {children}
        </Link>
    )
}

export default ButtonLink;
